import React, { useState } from "react";
import axios from "axios";
import "../styles/Home.css";


import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export default function AccountDelete() {
  const baseURL = "https://southin-cafe.crm-api.wifiattendance.com:3016";

  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [token, setToken] = useState("");
  const [showPopup, setShowPopup] = useState(false);


  const notify = (msg, type = "info") => {
    toast[type](msg, {
      position: "top-right",
      autoClose: 3000,
    });
  };
  
  const handleSendOtp = async () => {
    try {
      const res = await axios.post(`${baseURL}/api/user/sendOtp`, {
        phoneNumber,
        Hash: "plBv7KwrF62",
      });
      if (res.status === 200) {
    //  notify("OTP sent successfully", "success");
       notify("OTP sent successfully", "success");
        setOtpSent(true);
      }
    } catch (err) {
    
         notify("Failed to send OTP", "error");

    }
  };

  const handleLogin = async () => {
    try {
      const res = await axios.post(`${baseURL}/api/user/loginWithOtp`, {
        phoneNumber,
        otp,
      });
      if (res.data?.token) {
        setToken(res.data.token);
        setShowPopup(true);
      } else {

         notify("Invalid OTP", "error");
      }
    } catch (err) {
         notify("Login failed", "error");
    }
  };

  const handleDeleteAccount = async () => {
    try {
      await axios.delete(`${baseURL}/api/user/deleteUser/`, {
        headers: {
          Authorization: `jwt ${token}`,
        },
      });
      notify("Account deleted successfully", "success");
      setShowPopup(false);
    } catch (err) {
           notify("Failed to delete account", "error");
    }
  };

  return (
    <div> 
            <ToastContainer />
      <section
        className="terms-wrapper"
        style={{ marginLeft: "32px", marginRight: "32px" }}
      >
        <div className="terms-container">
          <h2 className="acc-1" style={{ fontSize: "2.5rem", color: "#39512f" }}>
            Delete Your Alfa Southin Cafe Account
          </h2>
          <p
            className="terms-subtitle acc-1"
            style={{ fontSize: "16px", color: "#3e3a35", marginTop: "40px" }}
          >
            Enter your phone number to receive OTP for login.
          </p>

          <div className="col-md-12 f22">
            <div className="f11">
              <input
                type="text"
                className="form-control"
                placeholder="Phone Number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
              <button
                type="button"
                className="btn btn-secondary mt-2"
                onClick={handleSendOtp}
              >
                Send OTP
              </button>
            </div>

            {otpSent && (
              <>
                <div className="f11 mt-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                </div>
                <div className="f11 f33 mt-3">
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ background: "#233140", border: "none" }}
                    onClick={handleLogin}
                  >
                    Log In
                  </button>
                </div>
              </>
            )}
          </div>
        </div>

        {showPopup && (
          <div className="popup-overlay">
            <div className="popup-content">
              <h4>Confirm Deletion</h4>
              <p>Do you really want to delete your account?</p>
              <button className="btn btn-danger" onClick={handleDeleteAccount}>
                Yes, Delete
              </button>
             <button
  className="btn btn-secondary ms-2"
  onClick={() => {
    setShowPopup(false);
    setPhoneNumber("");
    setOtp("");
    setToken("");
    setOtpSent(false);
  }}
>
  Cancel
</button>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
